<template>
<!-- 农批 -->
  <div class="banners">
    <div class="wholesale_programme_title">
      <div class="wholesale_programme_title_text">
        智慧农批解决方案
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian"></div>
  
    </div>

    <div class="wholesale_text">
      <p>
        禾平数据打造的智慧农批平台，旨在为农产品批发市场管理方及商户提供一站式系统解决方案，
      </p>
      <p>
        搭建包括市场运营管理、进出场管理、园区管理、防疫及质检追溯管理、商户经营管理等功能的批发市场综合服务平台，
      </p>
      <p>为市场提供数字化管理手段，为批发商提供精细化经营工具。</p>
    </div>

    <div class="wholesale_img_box">
      <img class="wholesale_img" src="../../assets/img/zhnp_1@2x.png" alt="" />
    </div>

    <div class="wholesale_Administration">
      <div class="wholesale_programme_title">
        <div class="wholesale_programme_title_text" style="width: 360px">
          一站式市场数字化运营管理
          <img src="../../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian"></div>
      </div>
      <div class="wholesale_Administration_box">
        <div
          class="wholesale_Administration_box_list"
          v-for="(item, index) in Administrationlist"
          :key="index"
        >
          <img :src="item.url" alt="" />
          <p>{{ item.p1 }}</p>
          <i>{{ item.p2 }}</i>
          <i>{{ item.p3 }}</i>
        </div>
      </div>
    </div>

    <div class="wholesale_center_box">
      <div style="width: 1200px; display: flex; margin: 0 auto">
        <div class="center1_left" style="width: 600px">
          <p>商户进销存平台</p>
          <i>系统功能：<span>现场开单收银、数据安全管理、多种统计数据报表、进销存</span></i>
          <i><span>检数据全面关联、数据分析提供经营决策数据</span></i>
        </div>
        <div
          class="center1_right"
          style="
            width: 600px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          "
        >
          <div
            class="center1_right_box"
            v-for="(item, index) in centerright"
            :key="index"
          >
            <img :src="item.url" alt="" />
            <div style="margin-left: 16px">
              <p>{{ item.p1 }}</p>
              <i>{{ item.p2 }}</i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="wholesale_center_box"
      style="background: #f7fbff; border-radius: 4px"
    >
      <div style="width: 1200px; display: flex; margin: 0 auto">
        <img
          style="width: 600px; height: 324px"
          src="../../assets/img/dy_5@2x.png"
          alt=""
        />
        <div class="touminghua" style="width: 600px">
          <p>市场大数据透明可视化</p>
          <i
            >市场行情：<span>商品信息、商品排名、价格公示、行情公示、追溯公示、农残检测公示商户信息公示</span></i
          >
          <i
            >市场运营：<span>市场商户数据、市场销售数据、市场业态分析及数据分析提供经营决策</span></i
          >
        </div>
      </div>
    </div>

    <div  class="wholesale_center_box" >
        <div style="width: 1200px; display: flex; margin: 0 auto">
            <div class="zhifu">
                <p>支付结算系统</p>
                <i>系统机制：<span>聚合支付、一键扫码、支持多种支付方式、统一结算分账</span></i>
                <i>系统效益：<span>支付无阻、避免二清、节省人力、提供增值服务</span></i>
            </div>
            <img style="width:600px;height:301px;" src="../../assets/img/dy_51@2x.png" alt="">
        </div>
    </div>

  <div class="wholesale_programme_title" style="margin-top: 71px;">
      <div class="wholesale_programme_title_text" style="width:240px;">
        六大产品体系支撑
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian" style="margin-bottom: 50px;"></div>
  </div>

  <div class="zhicheng_font" style="display: flex;width:100%; margin-bottom: 50px;">
      <div>市场运营管理平台</div>
      <div>商户进销存平台</div>
      <div>支付结算系统</div>
      <div>物联网平台</div>
      <div>电子会员系统</div>
      <div>线上商城系统</div>
  </div>
  </div>
</template>
 
 <script>
export default {
  data() {
    return {
      Administrationlist: [
        {
          url: require("../../assets/img/yz_1@2x.png"),
          p1: "资源管理",
          p2: "市场摊位、仓储、车位、公",
          p3: "寓等基础资源数字化管理",
        },
        {
          url: require("../../assets/img/yz_2@2x.png"),
          p1: "资产租赁",
          p2: "市场资源租赁流程化管理",
          p3: "包括电子合同、费用账单",
        },
        {
          url: require("../../assets/img/yz_3@2x.png"),
          p1: "收费管理",
          p2: "支持多种收费方式，移动收",
          p3: "费、自主缴费，逾期催收",
        },
        {
          url: require("../../assets/img/yz_4@2x.png"),
          p1: "店铺管理",
          p2: "商户信息、店铺信息数字化",
          p3: "管理，掌握商户经营数据",
        },
        {
          url: require("../../assets/img/yz_5@2x.png"),
          p1: "质检溯源",
          p2: "货品质检报告数字化，供货",
          p3: "进场到销售出场可全程溯源",
        },
        {
          url: require("../../assets/img/yz_6@2x.png"),
          p1: "进出场管理",

          p2: "智能设备无缝对接，实现人",
          p3: "车、货的智能化管理",
        },
        {
          url: require("../../assets/img/yz_7@2x.png"),
          p1: "市场服务",

          p2: "提供卸货、货物配送、快递",
          p3: "物流、报事报修等服务",
        },
        {
          url: require("../../assets/img/yz_8@2x.png"),
          p1: "信息公示",

          p2: "数据大屏、公众号、会员小",
          p3: "程序多渠道信息推送",
        },
      ],
      centerright: [
        {
          url: require("../../assets/img/dy_1@2x.png"),
          p1: "商品管理",
          p2: "商品信息准确掌握",
        },
        {
          url: require("../../assets/img/dy_2@2x.png"),
          p1: "开单销售",
          p2: "在线开单快速便捷",
        },
        {
          url: require("../../assets/img/dy_3@2x.png"),
          p1: "经营报表",
          p2: "经营数据清晰明了",
        },
        {
          url: require("../../assets/img/dy_4@2x.png"),
          p1: "赊销支付",
          p2: "降低赊账风险系数",
        },
      ],
    };
  },
  created(){
     this.$store.commit("solutions", -1);
    this.$store.commit("solutions", 0);
  }
};
</script>
 <style scoped>
.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}
.wholesale_programme_title_text {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -15px;
}
.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}
.wholesale_text {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
  line-height: 26px;
}
.wholesale_img {
  width: 1200px;
  height: 582px;
}
.wholesale_img_box {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}
.wholesale_Administration {
  width: 100%;
  height: 750px;
  background: #f7fbff;
  border-radius: 4px;
  padding-top: 60px;
  margin-top: 60px;
}
.wholesale_Administration_box {
  width: 1200px;
  margin: 0 auto;
  margin-top: 26px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.wholesale_Administration_box_list {
  width: 282px;
  height: 282px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  text-align: center;
  margin-top: 24px;
}
.wholesale_Administration_box_list img {
  width: 282px;
  height: 178px;
}
.wholesale_Administration_box_list p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}
.wholesale_Administration_box_list i {
  display: block;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}
.wholesale_center_box {
  width: 100%;
  height: 325px;
}
.center1_left p {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  line-height: 42px;
  margin-left: 50px;
  margin-top: 106px;
  margin-bottom: 16px;
}
.wholesale_center_box span{
      font-weight: 400;
}
.center1_left i {
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  margin-left: 50px;
}
.center1_right_box {
  margin-top: 40px;
  display: flex;
  margin-left: 50px;
  margin-right: 10px;
}
.center1_right_box img {
  width: 100px;
  height: 100px;
}
.center1_right_box p {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-top: 22px;
  margin-bottom: 6px;
}
.center1_right_box i {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}
.touminghua p {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  line-height: 42px;
  margin-left: 49px;
  margin-top: 74px;
  margin-bottom: 16px;
}
.touminghua i {
  display: block;
  width: 500px;
  word-break: break-all;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  margin-left: 49px;
  margin-bottom: 8px;
}
.zhifu{
    width: 600px;
}
.zhifu p{
   font-size: 30px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #1958C4;
line-height: 42px; 
margin-left: 50px;
margin-top: 90px;
margin-bottom: 16px;
}
.zhifu i{
    display: block;
   font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #333333;
line-height: 28px; 
margin-top: 8px;
margin-left: 50px;

}
.zhicheng_font div{
    width: 17%;
    height: 5%; 
    background-repeat:no-repeat;
    background-size: cover;
    text-align: center;
    line-height: 220px;
    font-size: 22px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #FFFFFF;

text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
}
.zhicheng_font div:nth-child(1){
    background-image: url("../../assets/img/ld_1@2x.png") ;

}
.zhicheng_font div:nth-child(2){
    background-image: url("../../assets/img/ld_2@2x.png") ;

}
.zhicheng_font div:nth-child(3){
    background-image: url("../../assets/img/ld_3@2x.png") ;

}
.zhicheng_font div:nth-child(4){
    background-image: url("../../assets/img/ld_4@2x.png") ;

}
.zhicheng_font div:nth-child(5){
    background-image: url("../../assets/img/ld_6@2x.png") ;

}
.zhicheng_font div:nth-child(6){
    background-image: url("../../assets/img/ld_7@2x.png") ;

}
</style>
 
